export default {
  login: {
    welcomeMsg: "Selamat Datang! Login",
    info: "Masukkan kredensial Anda.",
    forgot: "Lupa Kata Sandi?",
    btn: "Login",
    unableToLogin: "Tidak dapat Login",
  },
  forgot: {
    info_l1:
      "Masukkan alamat email yang terkait dengan akun Anda. Detail kata sandi akan dikirimkan ke email/alamat ponsel Anda.",
    info_l2:
      "Masukkan nomor ponsel yang terkait dengan akun Anda. Detail kata sandi akan dikirimkan ke nomor telepon.",
    info_l3:
      "Silakan pilih salah satu opsi berikut untuk menerima petunjuk tentang cara mengatur ulang kata sandi Anda",
    forgotQ: "Lupa Kata Sandi Anda?",
    loginNow: "Login Sekarang",
    resetSucc: "Kata sandi Anda berhasil direset",
    resetSucc_l2:
      "Anda sekarang dapat menggunakan kata sandi baru Anda untuk masuk ke akun Anda.",
    entPsw: "Silakan masukkan kata sandi baru Anda.",
    resetPsw: "Reset Kata Sandi Anda",
    resendOTP: "Kirim Ulang OTP",
    enterCorrectOTP: "Silakan masukkan OTP yang benar.",
    enterOTP: "Silakan masukkan OTP yang diterima melalui email/ponsel.",
    backToLoginPage: "Kembali ke halaman Login",
    recieveCodeFalse: "Saya tidak menerima kode",

    "changePassword": "Ganti Kata Sandi",
    "changePasswordSubtitle": "Silakan masukkan kata sandi baru Anda di bawah ini",
    "oldPassword": "Kata Sandi Lama",
    "newPassword": "Kata Sandi Baru",
    "confirmPassword": "Konfirmasi Kata Sandi",
    "resetPassword": "Atur Ulang Kata Sandi",
    "resetPasswordSubtitle": "Silakan masukkan kata sandi baru Anda di bawah ini",
    "resetPasswordBtn": "Atur Ulang Kata Sandi",
    "backToLogin": "Kembali ke Login",
    "oldPasswordRequired": "Kata sandi lama wajib diisi",
    "passwordResetSuccess": "Berhasil mengatur ulang kata sandi",
    "passwordResetFailed": "Gagal mengatur ulang kata sandi",
    "errorOccurred": "Terjadi kesalahan"
  },
  permissions: {
    savePermissions: "SIMPAN IZIN",
    moduleName: "Nama Modul",
    view: "Lihat",
    create: "Buat",
    update: "Perbarui",
    delete: "Hapus",
    permissionsUpdated: "Izin Diperbarui",
    permissionsNotUpdated: "Izin tidak Diperbarui",
    selectMembership: "Pilih Keanggotaan",
    noPermMsg:
      "Harap pilih jenis keanggotaan menggunakan dropdown 'Jenis Keanggotaan' di atas untuk melihat izin Anda",
    selectRoleMsg: "Harap pilih Peran di atas untuk menampilkan izin",
  },
  activationKey: {
    activationKey: "Kunci Aktivasi",
    viewActKey: "LIHAT KUNCI AKTIVASI",
    actKeyQuota: "Kuota Kunci Aktivasi",
    genActKey: "Kunci Aktivasi yang Dihasilkan",
    remActKey: "Kunci Aktivasi yang Tersisa",
    penUsed: "Kunci yang Tertunda dan Digunakan",
    activationKeyAss: "Kunci Aktivasi yang Ditugaskan",
    activationKeyUnass: "Kunci Aktivasi yang Belum Ditugaskan",
    keysAct: "Kunci yang Diaktifkan",
    uploadedFiles: "File yang Diupload",
    generateActKey: "HASILKAN KUNCI AKTIVASI",
    showData: "Tampilkan Data",
    noDataFound: "Tidak Ada Data Ditemukan",
    pleaseGenKey: 'Silakan hasilkan kunci aktivasi menggunakan "Hasilkan Kunci Aktivasi"',
    noActKey: "Belum ada kunci aktivasi yang dihasilkan",
    buttonAbv: "tombol di atas",
    numberOfActKey: "Jumlah Kunci Aktivasi",
    membershipRole: "Peran Keanggotaan",
    membershipPlan: "Paket Keanggotaan",
    comments: "Komentar",
    genKeys: "HASILKAN KUNCI",
    keysNum: "Jumlah Kunci",
    phoneNumber: "Nomor Telepon",
    keysStatus: "Status Kunci",
    ActivationKeysList: "Daftar Kunci Aktivasi",
    back: "KEMBALI",
    usingActKeys: 'menggunakan "Hasilkan Kunci Aktivasi"',
    pleaseGenActKeyss: "Silakan hasilkan kunci aktivasi",
    clearAllFilters: "HAPUS SEMUA FILTER",
    salesManager: "Manajer Penjualan",
    clearAll: "HAPUS SEMUA",
    generatedBy: "Dihasilkan Oleh",
    numberOfKeys: "Jumlah Kunci",
    action: "Aksi",
    viewAllUplFiles: "LIHAT SEMUA FILE YANG DIUPLOAD",
    bulkUploadUsers: "UPLOAD MASSAL PENGGUNA",
    noActivationKeyFound: "Tidak Ada Kunci Aktivasi Ditemukan",
    pleaseCreateAdminRole: "Silakan buat peran admin menggunakan",
    btnCreateAdmin: "tombol 'Buat Peran Admin' di atas",
    donwloadAsCsv: "Unduh sebagai CSV",
    donwloadAsPdf: "Unduh sebagai PDF",
    assignSalesManager: "Tugaskan Manajer Penjualan",
    shareViaEmail: "Bagikan lewat Email",
    memberRequired: "keanggotaan diperlukan",
    memberRoleRequired: "Peran keanggotaan diperlukan",
    memberKeyRequired: "Nilai kunci diperlukan",
    enterComment: "Masukkan komentar Anda di sini",
    sendEmail: "KIRIM EMAIL",
    emailSend: "EMAIL BERHASIL DIKIRIM",
    donwload: "Unduh",
    deleteFile: "Hapus File",
    invalidFileData: "Data kunci aktivasi, email, dan nomor telepon di file tidak valid",



    logs: {
      userId: "ID Pengguna",
    },

    memberDataSection: {
      import: "Impor",
      buyingStation: "Stasiun Pembelian",
      continue: "Lanjutkan",
      farmerId: "ID Petani",
      farmerName: "Nama Petani",
      farmerAddress: "Alamat Petani",
      quality: "Kualitas",
      quantity: "Kuantitas",
      importAll: "Impor Semua",
      importSelected: "Impor yang Dipilih",
      fileLoaded: "File berhasil dimuat",
      incorrectHeaders: "Header tidak sesuai",
      processingBatch: "Memproses Batch",
      purchaseOrder: "Pesanan Pembelian",
      startDate: "Tanggal Mulai",
      endDate: "Tanggal Selesai",
      purchasingOrder: "Pesanan Pembelian",
      totalCoffeeCherry: "Total Ceri Kopi",
      airHumidity: "Kelembapan Udara",
      density: "Kepadatan",
      temperature: "Suhu",
      beanMoistureContent: "Kadar Air Biji",
      processType: "Jenis Proses",
      batchRating: "Pilih Peringkat Batch",
      purchaseDate: "Tanggal Pembelian",
      selectFarmer: "Pilih Petani",
      selectFarmers: "Pilih Petani",
      selectFarm: "Pilih Lahan",
      selectPlantation: "Pilih Perkebunan",
      coffeeVariety: "Varietas Kopi",
      coffeeSpecies: "Spesies Kopi",
      coffeeCherryQuantity: "Jumlah Ceri Kopi",
      coffeeCherryQuality: "Kualitas Ceri Kopi",
      coffeeType: "Jenis Kopi",
      pricePerKg: "Harga Per Kg",
      processingDone: "Proses Selesai",
      processedCoffeeOut: "Kopi yang Telah Diproses",
      farmer: "Petani",
      farm: "Lahan",
      plantation: "Perkebunan",
    
      // Lately added
      farmers: "Petani",
      farmLimitUsed: "Batas Lahan yang Digunakan",
      phoneNumber: "Nomor Telepon",
      farmSize: "Ukuran Lahan",
      farmLocation: "Lahan/Lokasi",
      date: "Tanggal",
      status: "Status",
      noFarmers: "Tidak Ada Petani Ditemukan",
      approveReject: "Setujui/Tolak",
      farms: "Lahan",
      crops: "Tanaman",
      equipment: "Peralatan",
      noFarms: "Tidak Ada Lahan Ditemukan",
      views: "Lihat",
      selectStatus: "Pilih Status",
      approved: "Disetujui",
      rejected: "Ditolak",
      reject: "Tolak",
      approve: "Setujui",
      cancel: "Batal",
      add: "Tambah",
      describeYourReason: "Jelaskan alasan Anda di sini",
      userInformation: "Informasi Pengguna",
      userFarmRequest: "Permintaan Lahan Pengguna",
      userFarmInformation: "Informasi Lahan Pengguna",
      activity: "Aktivitas",
      activityType: "Jenis Aktivitas",
      farmZone: "Zona Lahan",
      farmerView: "Tampilan Petani",
      cropType: "Jenis Tanaman",
      cropVarity: "Varietas Tanaman",
      area: "Luas",
      cost: "Biaya",
      geofence: "Geofence",
      map_views: "Tampilan Peta",
      viewAllFarms: "Lihat Semua Lahan",
      farmersDetails: "Detail Petani",
      download: "Unduh",
      pOrder: {
        addNew: "Tambah Baru",
        viewAll: "Lihat Semua",
        selectDate: "Pilih Tanggal",
        makeSelection: "Buat Pilihan",
        coffeeType: "Masukkan Jumlah Kopi",
        enterPrice: "Masukkan Harga",
        reqPurchaseDate: "Tanggal pembelian wajib diisi",
        reqFarmer: "Petani wajib dipilih",
        reqCoffeeQnty: "Jumlah Ceri Kopi wajib diisi",
        reqPrice: "Harga Per Kg wajib diisi",
        grandTotal: "TOTAL KESELURUHAN",
        selectDateRange: "Pilih Rentang Tanggal",
        import: "Impor",
        purchaseId: "ID Pembelian",
        purchaseDate: "Tanggal Pembelian",
        farmerName: "Nama Petani",
        quality: "Kualitas",
        quantity: "Kuantitas",
        pricePerKg: "Harga Per Kg",
        selectBuyingStation: "Pilih Stasiun Pembelian",
        searchUser: "Cari Pengguna",
        purchaseListView: "Tampilan Daftar Pembelian",
        viewBy: "Lihat berdasarkan",
        typeDensity: "Masukkan Kepadatan",
        typeTemperature: "Masukkan Suhu",
        typeWaterContent: "Masukkan Kadar Air",
      },
      farmActivity: "Aktivitas Lahan",
      showOnMap: "Tampilkan di Peta",
      farmInformation: "Informasi Lahan",
      dateOfEntry: "Tanggal Entri",
      farmID: "ID Lahan",
      ownershipType: "Jenis Kepemilikan",
      locationAddress: "Alamat Lokasi",
      goalType: "Jenis Tujuan",
      totalSize: "Ukuran Total",
      zones: "Zona",
      farmActivities: "Aktivitas Lahan",
      farmDetails: "Detail Lahan",
      totalFarmsRegistered: "Total Lahan Terdaftar",
      totalFarmArea: "Total Luas Lahan",
      totalZone: "Total Zona",
      zone: "Zona",
    
      totalCost: "Total Biaya",
      selectFarmZone: "Pilih Zona/Lahan",
      productionType: "Jenis Produksi",
      certifications: "Sertifikasi",
      geofences: "Geofence",
      farmsChart: "Grafik Lahan",
    }
    
  },
  profileSetting: {
    defaultOrganizationOTPForSignUp: "OTP Organisasi Default untuk Pendaftaran",
    whoreceivedthealert: "Siapa yang Menerima Pemberitahuan",
    otp: "OTP",
    passwordReuse: "Penggunaan Ulang Kata Sandi",
    organizationSplashScreen: "Splash Screen Organisasi",
    organizationSplash1: "Splash Organisasi",
    generateOtp: "Buat OTP",
    addAnother: "Tambah Lainnya",
    dragAndDropOr: "Tarik & Lepas atau Telusuri",
    browse: "Telusuri",
    save: "Simpan",
    profileAuthSettings: "Pengaturan Otentikasi Profil",
    changeSettings: "UBAH PENGATURAN",
    loginLogoutSettings: "Pengaturan Login/Logout",
    autoLogout: "Auto-logout",
    unsuccAtmp: "Percobaan Login Gagal",
    unsuccLoginLock: "Periode Penguncian Setelah Login Gagal",
    pswCrisetup: "Setup Kriteria Kata Sandi",
    pswLength: "Panjang Kata Sandi",
    noOfUniquePsw: "Jumlah Kata Sandi Unik yang Diperlukan",
    maxPswAge: "Maksimum Umur Kata Sandi",
    AccRangeOfchars: "Rentang Karakter yang Diterima",
    upperCase: "Huruf Besar",
    lowerCase: "Huruf Kecil",
    numbers: "Angka",
    specialChars: "Karakter Khusus",
    settingsUpdated: "Pengaturan Diperbarui",
    settingsNotUpdated: "Pengaturan Tidak Diperbarui",
    organization: "Organisasi",
    organizationLogo: "Logo Organisasi",
    organizationSplash: "Splash Screen Organisasi",
    cropsHarvestAlert: "Pemberitahuan Panen Tanaman",
    alertCrop: "Tanaman",
    alertCropInfo: "Tanaman yang akan Anda terima pemberitahuan",
    alertCountry: "Negara",
    alertCountryInfo: "Negara yang akan Anda terima pemberitahuan",
    alertRegion: "Region",
    alertRegionInfo:
      "Region dari negara yang dipilih untuk Anda terima pemberitahuan",
    alertMaximum: "Jumlah Maksimum",
    alertMaximumInfo:
      "Jumlah maksimum yang diizinkan setelah itu Anda akan menerima pemberitahuan",
    selectCrop: "Pilih Tanaman",
    alertFor: "Pilih siapa yang menerima pemberitahuan",
    alertAdmin: "Admin Pemberitahuan",
    alertFarmer: "Petani Pemberitahuan",
    selectCountry: "Pilih Negara",
    selectCountryInfo: "Pilih lokasi geografis yang berlaku untuk penilaian.",
    maxProduction: "Produksi Maksimum / Hektar / Tahun",
    maxAllowed: "Maksimum yang Diizinkan / Ha / Tahun",
    alert: "Pemberitahuan",
    defaultOtpOrganization: "OTP organisasi default untuk pendaftaran",
    crop: "Tanaman",
    maxProductionError: "Produksi Maksimum harus diisi",
    selectCountryError: "Silakan pilih negara terlebih dahulu",
    selectCropError: "Silakan pilih tanaman terlebih dahulu",
    unitError: "Harap atur produksi maksimum dan unit",
      per_hour: "Per jam",
      mins: "Menit",
      days: "Hari",
  },
  adminRoles: {
    adminRoles: "Peran Admin",
    roleName: "Nama Peran",
    description: "Deskripsi",
    viewPermissions: "Lihat Izin",
    createAdminRole: "BUAT PERAN ADMIN",
    enterDesHere: "Masukkan deskripsi Anda di sini",
    deleteRole: "Hapus Peran",
    deleteMsg: "Anda yakin ingin menghapus peran?",
    roleReq: "Nama peran dibutuhkan",
    roleLimit: "Nama peran harus kurang dari 15 karakter",
    desReq: "Deskripsi dibutuhkan",
    desLimit: "Deskripsi harus 40 karakter atau kurang",
    roleSuccess: "Peran berhasil dibuat",
    editAdminRole: "Edit Peran Admin",
    roleUpdated: "Peran diperbarui",
    noRole: "Tidak ada Peran Admin Ditemukan",
    noRoleMsg:
      "Harap buat peran admin menggunakan tombol 'Buat Peran Admin' di atas",
    roleType: "Jenis Peran",
  },
  roleRequest: {
      "roleRequest": "Permintaan Peran",
  "userRole": "Peran Pengguna",
  "approve": "Setujui",
  "reject": "Tolak",
  "username": "Nama Pengguna",
  "email": "Email",
  "phone": "Telepon",
  "roleAssigned": "Peran yang Ditetapkan",
  "roleRequested": "Peran yang Diminta",
  "requestedDate": "Tanggal Permintaan",
  "updateRoleRequest": "Perbarui Permintaan Peran",
  "message": "Pesan",
  "update": "Perbarui",
    discard: "Buang",
    saveAndContinueLater: "Simpan & lanjutkan nanti",
    requestAdditionalInformation: "Meminta informasi tambahan",
    requestAdditionalInformationShort: "Minta lebih banyak info",
    uploadToEudr: "Unggah ke EUDR",
    productionPlaces: "Tempat Produksi",
    next: "Berikutnya",
    dueDeligenceReportCreation: "Pembuatan Laporan Uji Tuntas",
    producer: "Produsen",
    select: "Pilih",
    productionPlacesFarmAndFarmId:
      "Tempat produksi (Perkebunan) & ID Perkebunan",
    producerName: "Nama Produsen",
    addressOfProduction: "Alamat Produksi",
    type: "Jenis",
    geofence: "Pagar Geografis",
    areaHa: "Area (ha)",
    editGeofence: "Edit Pagar Geografis",
    totals: "Total",
    locationVerification: "Verifikasi Lokasi",
    AnalysisOfDeforestationStatus: "Analisis Status Deforestasi",
    EUDRDeforestationStatus: "Status Deforestasi EUDR",
    removeAllLowRiskFarm: "Hapus semua perkebunan berisiko rendah",
    removeAllHighRiskFarm: "Hapus semua perkebunan berisiko tinggi",
    attachRiskMigrationDoc:
      "Lampirkan dokumen mitigasi risiko untuk semua perkebunan berisiko tinggi",
    removedFarms: "Perkebunan dihapus dari daftar",
    generateCertificate: "Buat Sertifikat",
    viewDisputeHistory: "Lihat Riwayat Sengketa",
    disputeAssessment: "Penilaian Sengketa",
    reportDetails: "Detail Laporan",
    productionPlace: "Tempat Produksi",
    EUDRDeforestationAssessment: "Penilaian Deforestasi EUDR",
    riskAssessment: "Penilaian Risiko",
    legalInformation: "Informasi Hukum",
    finalReport: "Laporan Akhir",
    editGeolocation: "Edit Geolokasi",
    producerCountry: "Negara Produsen",
    manuallyAddData: "Tambahkan Data Secara Manual",
    drawGeofence: "Gambar Pagar Geografis",
    uploadFile: "Unggah File",
    typeyourlocation: "Ketik nama/alamat lokasi Anda",
    numberOfPoints: "Jumlah Titik Poligon",
    viewGeolocation: "Lihat Geolokasi",
    geoLocation: "Geolokasi",
    Point: "Titik",
    Polygon: "Poligon",
    selectFileToUploadData: "Pilih file untuk mengunggah data",
    loadingProductionPlaces: "Memuat Tempat Produksi",
    remove: "Hapus",
    restore: "Pulihkan",

    riskMitigation: "Mitigasi Risiko",
    assessmentRiskMitigation: "Mitigasi Risiko Penilaian",

    submissionDate: "Tanggal Pengajuan",
    eudrReferenceNo: "Nomor Referensi EUDR",
    internalReferenceNo: "Nomor Referensi Internal",
    exporter: "Eksportir",
    exporterInfo:
      "Nama Eksportir. Entitas atau pihak yang bertanggung jawab untuk mengekspor barang.",
    importer: "Importir",
    importerInfo:
      "Nama Importir. Entitas atau pihak yang bertanggung jawab untuk mengimpor barang.",
    shipmentReferenceNo: "Nomor Referensi Pengiriman",
    shipmentReferenceNoInfo:
      "Pengidentifikasi unik yang digunakan untuk merujuk pada pengiriman.",
    ownerShipType: "Jenis Kepemilikan",
    ownerShipTypeInfo: "Jenis kepemilikan yang terkait dengan pengiriman.",
    buyer: "Pembeli",
    port_of_origin: "Pelabuhan Asal",
    port_of_destination: "Pelabuhan Tujuan",
    no_of_stops: "Jumlah Pemberhentian",
    shipping_line: "Jalur Pengiriman",
    expected_arrival_date: "Tanggal Kedatangan yang Diharapkan",
    container_id: "ID Kontainer",
    container_type: "Jenis Kontainer",
    container_size: "Ukuran Kontainer (ft)",
    container_capacity: "Kapasitas Kontainer (Ton)",
    eudr_reference_number: "Nomor Referensi EUDR",

    select_default_measurement_units: "Pilih Satuan Pengukuran Default",

    maximum_limit: "Batas Maksimum",
    product_mass: "Massa Produk",
    user_type: "Jenis Pengguna",
    eudr_api_keys: "Kunci API Portal EUDR",
    api_key: "Kunci API",
    api_secret: "Rahasia API",
    assessment_risk_mitigation_levels: "Tingkat Mitigasi Risiko Penilaian",
    dynamic_expiry_time_period: "Periode Kedaluwarsa Dinamis",
    eudr_deforestation_assessment: "Penilaian Deforestasi EUDR",
    auto_renewal: "Perpanjangan Otomatis",
    auto_renewal_when_added_to_the_due_diligence_report:
      "Perpanjangan Otomatis Saat Ditambahkan ke Laporan Uji Tuntas",
    declaration_statements: "Pernyataan Deklarasi",
    filter_declaration_statements: "Saring Pernyataan Deklarasi",
    showing_all: "Menampilkan Semua",
    declaration_title: "Judul Deklarasi",
    applicable_countries: "Negara yang Berlaku",
    enabled: "Diaktifkan",
    disabled: "Dinonaktifkan",
    add_more: "Tambah Lagi",
    mark_as_default: "Tandai sebagai Default",
    locationVerificationTab: {
      confirmationTitle: "Konfirmasi",
      confirmationMessage:
        "Anda akan mengedit data geolokasi untuk pertanian ini. Harap dicatat bahwa setiap perubahan pada geolokasi akan memerlukan verifikasi ulang dari semua langkah terkait, termasuk verifikasi lokasi, analisis deforestasi, dan penilaian risiko regional (pemeriksaan area yang dilindungi dan adat). Perubahan pada nama perkebunan atau petani tidak akan memerlukan verifikasi ulang. Apakah Anda ingin melanjutkan?",
    },
    addFarm: "Tambahkan Perkebunan",
    importFarmsInBulk: "Impor Perkebunan Massal",
    importFarms: "Impor Perkebunan",
    importingNote:
      "File yang diunggah sedang diproses.\nJangan klik batal, tutup, atau refresh halaman ini untuk menghindari gangguan.",
    bulkImportNote:
      "Unduh dan gunakan template di bawah untuk impor massal perkebunan.",
    importCompleted: "Impor Selesai",
    farmerFirstName: "Nama Depan Petani",
    farmerMiddleName: "Nama Tengah Petani",
    farmerLastName: "Nama Belakang Petani",
    iAmNotFarmer: "Saya bukan petani",
    certifications: "Sertifikasi",
    productionType: "Tipe Produksi",
    deleted: "Perkebunan berhasil dihapus.",
    notDeleted: "Perkebunan tidak berhasil dihapus.",
    farmTitleDocument: "Dokumen Judul Perkebunan",
    dropHere: "atau seret dan lepas di sini",
    technicianName: "Nama Teknisi",

    farmRegistrationId: "ID Registrasi Perkebunan",
    farmerRegistrationId: "ID Registrasi Petani",
    farmId: "ID Perkebunan",
    farmerName: "Nama Petani",
    farmOwnershipType: "Tipe Kepemilikan Petani",
    farmGoals: "Tujuan Perkebunan",
    farmCertifications: "Sertifikasi Perkebunan",
    farmInfo: "Informasi Perkebunan",
    provinceState: "Provinsi/Negara Bagian",
    streetNumber: "Nomor Jalan",
    addGeofenceForThisFarm: "Tambahkan geofence untuk perkebunan ini",
    pleaseClickToChooseLocation: "Klik untuk memilih lokasi",
    address: "Alamat",
    geographicLocation: "Lokasi Geografis",
    searchLocation: "Cari Lokasi",
    pleaseChooseOneOfTheOption: "Silakan pilih salah satu opsi",
    useGeoFencingFeature: "Gunakan fitur geofencing",
    uploadShapeFile: "Unggah file bentuk",
    uploadGeofence: "Unggah Geofence",
    upload: "Unggah",
    reports: "Laporan",
    avocado: "Alpukat",
    avocadoTrees: "Pohon Alpukat",
    addNewFarmLocation: "Tambahkan Lokasi Perkebunan Baru",
    farmLocationAddress: "Alamat Lokasi Perkebunan",
    useGeofenceTool: "Gunakan alat geofencing",
    geofenceIsRequiredForSatelliteReport:
      "Catatan: Geofence diperlukan untuk Laporan Satelit",
    enterHere: "Masukkan di sini",
    primaryLocation: "Lokasi Utama",
    secondaryLocation: "Lokasi Sekunder",
    locationAndSize: "Lokasi dan Ukuran",
    addNewZone: "Tambahkan Zona Baru",
    noZoneMessage: "Belum ada zona yang terdaftar.",
    noZoneRequest:
      "Klik Tambahkan Zona Baru untuk membuat Zona untuk Perkebunan ini.",
    locationZone: "Zona Lokasi",
    editFarmLocation: "Edit Lokasi Perkebunan",
    addZone: "Tambahkan Zona",
    nameOfTheZone: "Nama Zona",
    zoneDetails: "Detail Zona",
    perimeter: "Perimeter",
    areaUnit: "Unit Luas",
    area: "Luas",
    zoneName: "Nama Zona",

    farmGeofence: "Geofence Perkebunan",
    circularGeofence: "Geofence Lingkaran",
    polygonGeofence: "Geofence Poligon",
    radius: "Radius",

    actions: "Tindakan",
    editZone: "Edit Zona",
    numberOfGroups: "Jumlah Kelompok",
    numberOfTrees: "Jumlah Pohon",
    group: "Grup",
    groupName: "Nama Grup",
    numberOfAnimals: "Jumlah Hewan",
    status: "Status",
    primaryGeofence: "Geofence Utama",
    walkAndMeasure: "Jalan dan Ukur",
    clearGeofence: "Bersihkan Geofence",
    deleteSelectedVertex: "Hapus Titik Terpilih",
    basicInformation: "Informasi Dasar",
    geofenceCategoryName: "Nama Kategori Geofence",
    geofenceName: "Nama Geofence",
    farmRadius: "Radius Perkebunan",
    locationDisabledMessage:
      "Lokasi Anda dinonaktifkan. Harap cari lokasi Anda dari menu kiri.",
    yourDistanceIs: "Jarak Anda adalah",
    searchFarmName: "Cari dengan Nama Perkebunan",
    pleaseSelectFarmType: "Silakan pilih jenis Perkebunan",
  },
  userslist: {
    existingUser: "Pilih dari pengguna aplikasi yang ada",
    addRole: "Tambah Peran",
    newUser: "Buat pengguna admin baru",
    convertUser: "Konversi ke pengguna admin",
    createNewUser: "Buat Pengguna Baru",
    chooseCreateType: "Silakan pilih salah satu dari opsi berikut:",
    addNewUser: "Tambah Pengguna Baru",
    editUser: "Edit Pengguna",
    addNewAdmin: "Tambah Pengguna Admin",
    userLoading: "Memuat Pengguna... Harap tunggu",
    noUser: "TIDAK ADA PENGUNA TERSEDIA",
    extendVal: "PERPANJANG VALIDITAS",
    extendReason: "Alasan Perpanjangan",
    extendReasonMsg: "Tentukan alasan perpanjangan keanggotaan",
    exportAsCSV: "EKSPOR SEBAGAI CSV",
    membershipType: "Jenis Keanggotaan",
    membershipValidity: "Validitas Keanggotaan",
    regionState: "Wilayah/Provinsi",
    cityTown: "Kota/Desa",
    clearAll: "BERSIHKAN SEMUA",
    search: "CARI",
    familyTribe: "Masukkan suku keluarga Anda",
    enterWebsite: "Masukkan website",
    registrationDate: "Tanggal Pendaftaran",
    single: "Tunggal",
    multiple: "Jamak",
    user: "Pengguna",
    users: "Pengguna",
    role: "Peran",
    department: "Departemen",
    bulkUploadUser: "Impor Pengguna Massal",
  },
  addEdituser: {
    facilityPicture: "Gambar Fasilitas",
    firstNameRequired: "Nama Depan wajib diisi",
    roleNameOnlyAlpha: "Nama Peran hanya dapat mengandung huruf",
    roleNameLimit: "Nama Peran harus kurang dari 100 karakter",
    firstNameOllyAlpha: "Nama Depan hanya dapat mengandung huruf",
    firstNameLimit: "Nama Depan harus kurang dari 50 karakter",
    departmentRequired: "Bidang Departemen wajib diisi",
    lastNameRequired: "Nama Belakang wajib diisi",
    lastNameOllyAlpha: "Nama Belakang hanya dapat mengandung huruf",
    lastNameLimit: "Nama Belakang harus kurang dari 50 karakter",
    emailReuired: "Email wajib diisi",
    emailInvalid: "Format email tidak valid",
    mobileRequired: "Nomor Handphone wajib diisi",
    invalidMobile: "Format nomor handphone tidak valid",
    emailExistAlready: "Pengguna sudah ada dengan email ini.",
    mobileExistAlready: "Pengguna sudah ada dengan nomor ponsel ini.",
    pswRequired: "Kata Sandi wajib diisi",
    deptRequired: "Departemen wajib diisi",
    roleRequired: "Peran wajib diisi",
    countryRequired: "Kode Negara wajib diisi",
    userUpdated: "Pengguna Diperbarui",
    userNotUpdated: "Pengguna Tidak Diperbarui",
    activateAct: "Aktifkan Akun",
    deactivateAct: "Nonaktifkan Akun",
    userActivated: "Pengguna Diaktifkan",
    userDeactivated: "Pengguna Dinonaktifkan",
    deactivateUser: "Nonaktifkan Pengguna",
    deactivateMsg: "Apakah Anda yakin ingin mengubah status pengguna?",
    userAdded: "Pengguna Ditambahkan",
    roleAdded: "Peran Ditambahkan",
    failedToAdd: "Gagal menambahkan",
    userNotAdded: "Pengguna Tidak Ditambahkan",
    editAppUser: "Edit Pengguna Aplikasi",
    validityUpTo: "Kebenaran Hingga",
    roleEdited: "Peran Diedit",
    addDepartment: "Tambah Departemen",
    editDepartment: "Edit Departemen",
    department: "Departemen",
    noDepartment: "Tidak ada Departemen",
    departmentNameRequired: "Nama Departemen wajib diisi",
    departmentAdded: "Departemen Ditambahkan",
    departmentEdited: "Departemen Diedit",
    addNewProducer: "Tambahkan Produsen Baru",
    addNewOperator: "Tambahkan Operator Baru",
    eoriNumber: "Nomor EORI",
  },
  membership: {
    remainingDays: "Jumlah Hari Diperpanjang",
    type: "Jenis Keanggotaan",
    validity: "Validitas Keanggotaan",
    validityLength: {
      custom: "Kustom",
      expired: "Kedaluwarsa",
      oneTo8Months: "1-8 bulan",
      lessThan1Month: "Kurang dari 1 bulan",
      moreThan1Month: "Lebih dari 1 tahun",
      sixTo12Months: "6-12 bulan",
    },
  },
  membershipplanSection: {
    defaultPlan: "PLAN DEFAULT",
    planDuration: "Durasi Rencana",
    planFee: "Biaya Paket",
    satelliteReport: "LAPORAN SATELIT",
    advanceReport: "LAPORAN LANJUTAN",
    addMembership: "TAMBAHKAN KEANGGOTAAN",
    addMembershipPlan: "Tambahkan Rencana Keanggotaan",
    editMembershipPlan: "Edit Rencana Keanggotaan",
    accessSetelite: "Akses ke Laporan Satelit (Set dari 5 laporan)",
    accessAdvanceReport: "Akses ke Laporan Lanjutan",
    memPlanReq: "Rencana Keanggotaan dibutuhkan",
    memPlanReqLimit: "Rencana keanggotaan harus kurang dari 20 karakter",
    SatelliteReq: "Laporan Satelit dibutuhkan",
    advancedReportReq: "Laporan Lanjutan dibutuhkan",
    durationReq: "Durasi Keanggotaan dibutuhkan",
    feeReq: "Biaya Keanggotaan dibutuhkan",
    cantLesThenZero: "Tidak boleh kurang dari 0",
    roleReq: "Peran Pengguna dibutuhkan",
    selectPlan: "Pilih Rencana",
    planType: "Tipe Rencana",
    enterprise: "Enterprise",
    noOfUsersAllowed: "Jumlah pengguna yang diizinkan",
    noOfFarms: "Jumlah pertanian",
    perUser: "Per Pengguna",
    perFarm: "Per Pertanian",
    accessToDeforestationReport: "Akses ke Laporan Deforestasi (Per Pengguna)",
    satelliteReportPackage: "Paket Laporan Satelit",
    basicFarmLevelReports: "Laporan Tingkat Pertanian Dasar",
    advancedFarmLevelReports: "Laporan Tingkat Pertanian Lanjutan",
    largeAreaReports: "Laporan Area Besar",
  },
  statusItems: {
    closed: "Tutup",
    open: "Buka",
  },
  orderByItems: {
    all: "Semua",
    dateAscending: "Tanggal (Menaik)",
    dateDescending: "Tanggal (Menurun)",
    dueDate: "Tanggal Jatuh Tempo",
    high: "Tinggi",
    low: "Rendah",
    medium: "Sedang",
  },
  record: {
    id: "ID",
    module: "Modul",
    harvestingDate: "Tanggal Panen",
    noOfTrees: "Jumlah Pohon",
    reason: "Alasan",
    userId: "ID Pengguna",
    appVersion: "Versi Aplikasi",
    createdAt: "Dibuat Pada",
  },
  ownershipTypes: {
    EXW: "EXW (Di Pabrik)",
    FCA: "FCA (Pengangkut Bebas)",
    CPT: "CPT (Pengangkutan Dibayar Sampai)",
    CIP: "CIP (Pengangkutan dan Asuransi Dibayar Sampai)",
    DAP: "DAP (Dikirim di Tempat)",
    DPU: "DPU (Dikirim di Tempat Dibongkar)",
    DDP: "DDP (Dikirim dengan Bea Dibayar)",
    FAS: "FAS (Bebas di Sisi Kapal)",
    FOB: "FOB (Bebas di Atas Kapal)",
    CFR: "CFR (Biaya dan Pengangkutan)",
    CIF: "CIF (Biaya, Asuransi, dan Pengangkutan)",
  },
};
